import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

export function masketTextBoxValidator( defaultValue: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isEmpty = (control.value == defaultValue) || (control.value == null);
      return isEmpty ? {isEmpty: true} : null;
    };
  }